
import {SyncedField} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfield';
import {SyncedFieldSetting} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfieldsetting';
import {MenuController} from '/ui/components/menu/menucontroller';

/**
 * @param {{
 *   syncedField: SyncedField,
 *   syncedFieldSetting: SyncedFieldSetting,
 *   setSyncedFieldSetting: Function
 * }} props
 */
export function ContentMappedFieldMenu({syncedField, syncedFieldSetting, setSyncedFieldSetting}) {
  if (syncedField.overrideFields.length === 0) {
    return '--';
  }
  const selectedField = syncedField.overrideFields
    .find(overrideField =>
      overrideField.key.id === syncedFieldSetting.overrideFieldKey?.id);

  const onSelect = overrideFieldKey => {
    setSyncedFieldSetting(new SyncedFieldSetting({
      syncedFieldKey: syncedFieldSetting.syncedFieldKey,
      overrideFieldKey,
      enabled: syncedFieldSetting.enabled,
      replaceExisting: syncedFieldSetting.replaceExisting,
      applyToNewSubAccounts: syncedFieldSetting.applyToNewSubAccounts,
    }));
  };

  const overrideFieldActions = syncedField.overrideFields
    .map(overrideField => {
      return {
        name: overrideField.name,
        callback: () => onSelect(overrideField.key),
      };
    });

  const defaultFieldName = `${syncedField.name} (${yext.msg('Default')})`;

  const defaultFieldAction = {
    name: defaultFieldName,
    callback: () => onSelect(undefined),
  };

  return <MenuController
    actions={overrideFieldActions.concat(defaultFieldAction)}
    label={selectedField === undefined ? defaultFieldName : selectedField?.name}
  />;
}
